import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { Settings2 } from 'lucide-react';
import { ImpactedParties } from '../ImpactedParties';
import { RemediationOptions } from '../RemediationOptions';
import { RootCauses } from '../RootCauses';
import { SolutionsImplemented } from '../SolutionsImplemented';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/incidents/general/rectification')({
    staticData: {
        metadata: {
            title: 'Rectification',
        },
        ui: {
            icon: Settings2,
            title: 'Incident settings',
            subtitle: 'Types, causes, impacts, timeline and lodgement form configuration',
        },
    },
    component: RectificationOptions,
});

function RectificationOptions() {
    return (
        <PageController route={Route}>
            <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-2">
                <RootCauses />
                <ImpactedParties />
                <SolutionsImplemented />
                <RemediationOptions />
            </div>
        </PageController>
    );
}
